module.exports = __webpack_public_path__ + "static/img/success9.2e0db57a.jpg";